import { createFileRoute } from "@tanstack/react-router";

import { ClientTabPage } from "@/features/booking/modules/client-page/client-tab-page";
import { ProgressOverview } from "@/features/progress/modules/progress-overview/progress-overview";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/progress/")({
  loader: () => ({ crumb: m.client_tab_progress() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId } = Route.useParams();
  return (
    <ClientTabPage clientId={clientId} tab="progress">
      <ProgressOverview clientId={clientId} />
    </ClientTabPage>
  );
}
